// frontend/src/components/layout/mobile/BottomSheet.jsx
//
// The phone layout's menu surface: a panel that slides up from the bottom of
// the screen, over MUI's backdrop. Swipe it down, tap outside it or press
// Escape to close it.

import { SwipeableDrawer } from '@mui/material';
import './BottomSheet.css';

// A sheet opens from the button that owns it, never from an edge swipe. With
// `disableSwipeToOpen` MUI never calls `onOpen`, which it still requires.
const OPENED_BY_ITS_BUTTON = () => {};

// SwipeableDrawer keeps a closed drawer mounted so an edge swipe can find its
// paper; with no swipe-to-open there is nothing to find, so a closed sheet
// leaves the page entirely.
const UNMOUNT_WHEN_CLOSED = { keepMounted: false };

/**
 * @param {{ open: boolean, onClose: () => void, label: string, children: React.ReactNode }} props
 *   `label` names the sheet for assistive technology.
 */
export default function BottomSheet({ open, onClose, label, children }) {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={OPENED_BY_ITS_BUTTON}
      disableSwipeToOpen
      ModalProps={UNMOUNT_WHEN_CLOSED}
      className="bottom-sheet"
      slotProps={{
        paper: { className: 'bottom-sheet__paper', role: 'dialog', 'aria-modal': true, 'aria-label': label },
      }}
    >
      <div className="bottom-sheet__handle" aria-hidden="true" />
      <div className="bottom-sheet__body">{children}</div>
    </SwipeableDrawer>
  );
}
